import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button, Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import { FaCheckCircle } from "react-icons/fa";
import { getTokenAttributes } from "../../redux/tokens";

/**
 * Table container used as app default landing page
 */
const TokenPreview = (props, context) => {
  const { tokenId, onSelect, selected } = props;

  const token = useSelector((state) => getTokenAttributes(state, tokenId));

  const handleOnclick = () => {
    if (onSelect) {
      onSelect({
        tokenId: tokenId,
        identifier: token.identifier,
        contract_address: token.contract_address,
      });
    }
  };

  return (
    <>
      <Card className="bg-grey shadow" onClick={handleOnclick}>
        <div className="position-relative">
          {token?.thumbnail && (
            <div className="ratio ratio-1x1">
              <img
                src={token?.thumbnail}
                className="card-img-top"
                alt={token?.name || context.t("Missing Name")}
              />
            </div>
          )}
          {selected && (
            <FaCheckCircle
              className="text-success position-absolute bottom-0 end-0 m-3"
              size={30}
            />
          )}
        </div>
        <CardBody>
          <CardTitle className="h6">#{token?.identifier}</CardTitle>
          <CardSubtitle className="mt-3 fw-bold">
            {token?.name || context.t("Missing Name")}
          </CardSubtitle>
          <Button
            block
            color={selected ? "success" : "primary"}
            className="mt-5"
          >
            {!selected ? context.t("Select") : context.t("Selected")}
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

/**  define proptypes for TokenPreview  */
TokenPreview.propTypes = {
  tokenId: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
};

/**  define defaultProps for TokenPreview  */
TokenPreview.defaulProps = {
  selected: false,
  onSelect: () => {},
};

/**  define proptype for the 'translation' function  */
TokenPreview.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default TokenPreview;
